import React, { useEffect, useRef, useState } from 'react';
import { IconChevronDown, IconLogout } from './Icons';

// Iniciais para o avatar: 1ª letra do 1º e do último nome; cai no e-mail.
function initialsOf(name, email) {
  const src = (name || email || '').trim();
  if (!src) return '?';
  const parts = src.replace(/@.*/, '').split(/[\s.]+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/**
 * Identificação do usuário no header (Ajuste 1 / CR-5): avatar com iniciais +
 * nome + menu suspenso com "Sair" — padrão de mercado, substitui o e-mail cru.
 */
function UserMenu({ displayName, email, onLogout }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onEsc = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onEsc);
    };
  }, []);

  const name = displayName || (email || '').split('@')[0];

  return (
    <div className={`user-menu${open ? ' is-open' : ''}`} ref={ref}>
      <button
        className="user-menu-trigger"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className="user-menu-avatar">{initialsOf(displayName, email)}</span>
        <span className="user-menu-name">{name}</span>
        <IconChevronDown className="user-menu-caret" size={16} />
      </button>

      {open && (
        <div className="user-menu-dropdown" role="menu">
          <div className="user-menu-id">
            <span className="user-menu-id-name">{name}</span>
            {email && <span className="user-menu-id-mail">{email}</span>}
          </div>
          <button className="user-menu-item" role="menuitem" onClick={onLogout}>
            <IconLogout size={16} /> Sair
          </button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;
